import React, { useState } from 'react';
import axios from 'axios';
import { 
  Box, Typography, TextField, Button, Switch, FormControlLabel, 
  Select, MenuItem, InputLabel, FormControl, IconButton, Autocomplete, Chip
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

const AddProduct = () => {
  const [product, setProduct] = useState({
    title: '',
    description: '',
    price: '',
    discount: '',
    category: '',
    subCategory1: '',
    subCategory2: '',
    brand: '',
    seller: '',
    availability: true,
    image: null,
    images: [],
    product_information: [{ key: '', value: '' }],
    tags: []
  });

  // Mock data for dropdowns - replace with actual data from your backend
  const categories = ['dog', 'cat', 'bird', 'fish'];
  const subCategories = ['alimentation', 'accessories', 'toys'];
  const brands = ['Brand A', 'Brand B', 'Brand C'];
  const sellers = ['Seller X', 'Seller Y', 'Seller Z'];
  const availableTags = ['organic', 'vegan', 'gluten-free', 'eco-friendly', 'premium', 'limited-edition'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduct(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleTagChange = (event, newValue) => {
    setProduct(prevState => ({
      ...prevState,
      tags: newValue
    }));
  };

  const handleSwitchChange = (e) => {
    setProduct(prevState => ({
      ...prevState,
      availability: e.target.checked
    }));
  };

  const handleImageUpload = (e) => {
    setProduct(prevState => ({
      ...prevState,
      image: e.target.files[0]
    }));
  };

  const handleMultiImageUpload = (e) => {
    setProduct(prevState => ({
      ...prevState,
      images: Array.from(e.target.files)
    }));
  };

  const handleProductInfoChange = (index, field, value) => {
    const updatedInfo = [...product.product_information];
    updatedInfo[index][field] = value;
    setProduct(prevState => ({
      ...prevState,
      product_information: updatedInfo
    }));
  };

  const addProductInfoField = () => {
    setProduct(prevState => ({
      ...prevState,
      product_information: [...prevState.product_information, { key: '', value: '' }]
    }));
  };

  const removeProductInfoField = (index) => {
    const updatedInfo = product.product_information.filter((_, i) => i !== index);
    setProduct(prevState => ({
      ...prevState,
      product_information: updatedInfo
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    Object.keys(product).forEach(key => {
      if (key === 'image') {
        if (product[key]) formData.append(key, product[key]);
      } else if (key === 'images') {
        product[key].forEach((file, index) => {
          formData.append(`images[${index}]`, file);
        });
      } else if (key === 'product_information' || key === 'tags') {
        formData.append(key, JSON.stringify(product[key]));
      } else if (key === 'availability') {
        formData.append(key, product[key].toString());
      } else {
        formData.append(key, product[key]);
      }
    });
    
    try {
      const response = await axios.post('https://cheebo-server.neuralbey.com/dashboard/store/productRegister/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      console.log('Product added successfully:', response.data);
      // Reset form or show success message
    } catch (error) {
      console.error('Failed to add product:', error);
      // Show error message to user
    }
  };

  return (
    <Box sx={{ maxWidth: 600, margin: 'auto', padding: 2 }}>
      <Typography variant="h4" gutterBottom>
        Add a New Product
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Title"
          name="title"
          value={product.title}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Description"
          name="description"
          multiline
          rows={4}
          value={product.description}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Price"
          name="price"
          type="number"
          value={product.price}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Discount"
          name="discount"
          type="number"
          value={product.discount}
          onChange={handleChange}
        />
        <FormControl fullWidth margin="normal">
          <InputLabel>Category</InputLabel>
          <Select
            name="category"
            value={product.category}
            onChange={handleChange}
            label="Category"
          >
            {categories.map(cat => (
              <MenuItem key={cat} value={cat}>{cat}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth margin="normal">
          <InputLabel>Sub-category 1</InputLabel>
          <Select
            name="subCategory1"
            value={product.subCategory1}
            onChange={handleChange}
            label="Sub-category 1"
          >
            {subCategories.map(subCat => (
              <MenuItem key={subCat} value={subCat}>{subCat}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth margin="normal">
          <InputLabel>Sub-category 2</InputLabel>
          <Select
            name="subCategory2"
            value={product.subCategory2}
            onChange={handleChange}
            label="Sub-category 2"
          >
            {subCategories.map(subCat => (
              <MenuItem key={subCat} value={subCat}>{subCat}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth margin="normal">
          <InputLabel>Brand</InputLabel>
          <Select
            name="brand"
            value={product.brand}
            onChange={handleChange}
            label="Brand"
          >
            {brands.map(brand => (
              <MenuItem key={brand} value={brand}>{brand}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth margin="normal">
          <InputLabel>Seller</InputLabel>
          <Select
            name="seller"
            value={product.seller}
            onChange={handleChange}
            label="Seller"
          >
            {sellers.map(seller => (
              <MenuItem key={seller} value={seller}>{seller}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Autocomplete
          multiple
          id="tags-outlined"
          options={availableTags}
          value={product.tags}
          onChange={handleTagChange}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Tags"
              placeholder="Select tags"
              margin="normal"
            />
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip variant="outlined" label={option} {...getTagProps({ index })} />
            ))
          }
        />
        <Box sx={{ margin: '20px 0' }}>
          <input
            accept="image/*"
            style={{ display: 'none' }}
            id="raised-button-file"
            type="file"
            onChange={handleImageUpload}
          />
          <label htmlFor="raised-button-file">
            <Button variant="contained" component="span">
              Upload Main Image
            </Button>
          </label>
          {product.image && <Typography variant="body2">{product.image.name}</Typography>}
        </Box>
        <Box sx={{ margin: '20px 0' }}>
          <input
            accept="image/*"
            style={{ display: 'none' }}
            id="raised-button-files"
            multiple
            type="file"
            onChange={handleMultiImageUpload}
          />
          <label htmlFor="raised-button-files">
            <Button variant="contained" component="span">
              Upload Additional Images
            </Button>
          </label>
          {product.images.length > 0 && (
            <Typography variant="body2">{product.images.length} files selected</Typography>
          )}
        </Box>
        <FormControlLabel
          control={
            <Switch
              checked={product.availability}
              onChange={handleSwitchChange}
              color="secondary"
              name="availability"
            />
          }
          label="Availability"
        />
        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
          Product Information
        </Typography>
        {product.product_information.map((info, index) => (
          <Box key={index} display="flex" alignItems="center" mb={1}>
            <TextField 
              label="Key"
              value={info.key}
              onChange={(e) => handleProductInfoChange(index, 'key', e.target.value)}
              margin="normal"
              style={{ marginRight: '8px' }}
            />
            <TextField 
              label="Value"
              value={info.value}
              onChange={(e) => handleProductInfoChange(index, 'value', e.target.value)}
              margin="normal"
              style={{ marginRight: '8px' }}
            />
            <IconButton onClick={() => removeProductInfoField(index)}>
              <DeleteIcon />
            </IconButton>
          </Box>
        ))}
        <Button color="secondary" startIcon={<AddIcon />} onClick={addProductInfoField}>
          Add Product Information
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="secondary"
          sx={{ mt: 2, display: 'block' }}
        >
          Add Product
        </Button>
      </form>
    </Box>
  );
};

export default AddProduct;